module.exports = __webpack_public_path__ + "img/pageNotFound.3dbcaa06.svg";